import {Action} from "redux";
import { 
    GetMultiSkillTagListRequest, 
    GetOccupationSkillTagListRequest, 
    GetSingleSkillTagListRequest} from "../request/skill_tag_request";

import { 
    MultiSkillTagListGetResponse,
    OccupationSkillTagListGetResponse,
    SingleSkillTagListGetResponse} from "../response/skill_tag_response";


export enum SingleSkillTagActionType {
    REQUSET_GET_SINGLE_SKILL_TAG_LIST = "REQUSET_GET_SINGLE_SKILL_TAG_LIST",
    CALLBACK_GET_SINGLE_SKILL_TAG_LIST = "CALLBACK_GET_SINGLE_SKILL_TAG_LIST",
}

export enum MultiSkillTagActionType {
    REQUSET_GET_MULTI_SKILL_TAG_LIST = "REQUSET_GET_MULTI_SKILL_TAG_LIST",
    CALLBACK_GET_MULTI_SKILL_TAG_LIST = "CALLBACK_GET_MULTI_SKILL_TAG_LIST",
}

export enum OccupationSkillTagActionType {
    REQUSET_GET_OCCUPATION_SKILL_TAG_LIST = "REQUSET_GET_OCCUPATION_SKILL_TAG_LIST",
    CALLBACK_GET_OCCUPATION_SKILL_TAG_LIST = "CALLBACK_GET_OCCUPATION_SKILL_TAG_LIST",
}

// single
export interface IRequestGetSingleSkillTagListAction extends Action {
    type: SingleSkillTagActionType.REQUSET_GET_SINGLE_SKILL_TAG_LIST;
    item: GetSingleSkillTagListRequest;
}

export interface ICallbackGetSingleSkillTagListAction extends Action {
    type: SingleSkillTagActionType.CALLBACK_GET_SINGLE_SKILL_TAG_LIST;
    isSuccess: boolean;
    item?: SingleSkillTagListGetResponse;
}


// multi
export interface IRequestGetMultiSkillTagListAction extends Action {
    type: MultiSkillTagActionType.REQUSET_GET_MULTI_SKILL_TAG_LIST;
    item: GetMultiSkillTagListRequest;
}

export interface ICallbackGetMultiSkillTagListAction extends Action {
    type: MultiSkillTagActionType.CALLBACK_GET_MULTI_SKILL_TAG_LIST;
    isSuccess: boolean;
    item?: MultiSkillTagListGetResponse;
}

// occupation
export interface IRequestGetOccupationSkillTagListAction extends Action {
    type: OccupationSkillTagActionType.REQUSET_GET_OCCUPATION_SKILL_TAG_LIST;
    item: GetOccupationSkillTagListRequest;
}

export interface ICallbackGetOccupationSkillTagListAction extends Action {
    type: OccupationSkillTagActionType.CALLBACK_GET_OCCUPATION_SKILL_TAG_LIST;
    isSuccess: boolean;
    item?: OccupationSkillTagListGetResponse;
}


export type SkillTagAction =
    IRequestGetSingleSkillTagListAction |
    ICallbackGetSingleSkillTagListAction |

    IRequestGetMultiSkillTagListAction |
    ICallbackGetMultiSkillTagListAction |

    IRequestGetOccupationSkillTagListAction |
    ICallbackGetOccupationSkillTagListAction;


export interface ISkillTagActionCreator {

    // single
    requestGetSingleSkillTagListAction(
        item: GetSingleSkillTagListRequest,
    ): IRequestGetSingleSkillTagListAction;

    callbackGetSingleSkillTagListAction(
        isSuccess: boolean,
        item?: SingleSkillTagListGetResponse,
    ): ICallbackGetSingleSkillTagListAction;


    // multi
    requestGetMultiSkillTagListAction(
        item: GetMultiSkillTagListRequest,
    ): IRequestGetMultiSkillTagListAction;

    callbackGetMultiSkillTagListAction(
        isSuccess: boolean,
        item?: MultiSkillTagListGetResponse,
    ): ICallbackGetMultiSkillTagListAction;

    // occupation
    requestGetOccupationSkillTagListAction(
        item: GetOccupationSkillTagListRequest,
    ): IRequestGetOccupationSkillTagListAction;

    callbackGetOccupationSkillTagListAction(
        isSuccess: boolean,
        item?: OccupationSkillTagListGetResponse,
    ): ICallbackGetOccupationSkillTagListAction;
}

class ActionCreator implements ISkillTagActionCreator {

    // single
    public requestGetSingleSkillTagListAction = (
        item: GetSingleSkillTagListRequest,
    ): IRequestGetSingleSkillTagListAction => {
        return {
            type: SingleSkillTagActionType.REQUSET_GET_SINGLE_SKILL_TAG_LIST,
            item,
        };
    };

    public callbackGetSingleSkillTagListAction = (
        isSuccess: boolean,
        item?: SingleSkillTagListGetResponse,
    ): ICallbackGetSingleSkillTagListAction => {
        return {
            type: SingleSkillTagActionType.CALLBACK_GET_SINGLE_SKILL_TAG_LIST,
            isSuccess,
            item,
        };
    };


    // multi
    public requestGetMultiSkillTagListAction = (
        item: GetMultiSkillTagListRequest,
    ): IRequestGetMultiSkillTagListAction => {
        return {
            type: MultiSkillTagActionType.REQUSET_GET_MULTI_SKILL_TAG_LIST,
            item,
        };
    };

    public callbackGetMultiSkillTagListAction = (
        isSuccess: boolean,
        item?: MultiSkillTagListGetResponse,
    ): ICallbackGetMultiSkillTagListAction => {
        return {
            type: MultiSkillTagActionType.CALLBACK_GET_MULTI_SKILL_TAG_LIST,
            isSuccess,
            item,
        };
    };

    // occupation
    public requestGetOccupationSkillTagListAction = (
        item: GetOccupationSkillTagListRequest,
    ): IRequestGetOccupationSkillTagListAction => {
        return {
            type: OccupationSkillTagActionType.REQUSET_GET_OCCUPATION_SKILL_TAG_LIST,
            item,
        };
    };

    public callbackGetOccupationSkillTagListAction = (
        isSuccess: boolean,
        item?: OccupationSkillTagListGetResponse,
    ): ICallbackGetOccupationSkillTagListAction => {
        return {
            type: OccupationSkillTagActionType.CALLBACK_GET_OCCUPATION_SKILL_TAG_LIST,
            isSuccess,
            item,
        };
    };
}

export const createSkillTagActionCreator = (): ISkillTagActionCreator => {
    return new ActionCreator();
};



// WEBPACK FOOTER //
// ./src/presentation/action/skill_tag_action.ts